module.exports = __webpack_public_path__ + "static/media/email.4ccb23b4.svg";